var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 71,
    viewBox: "0 0 200 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1164",
    "data-name": "Rectangle 1164",
    width: 117.8,
    height: 34.2,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(-320 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(320 538.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    transform: "translate(0 0.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71,
    rx: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 70,
    rx: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "secure-shield_388531",
    transform: "translate(21.612 19.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M64.6,5.551A53.473,53.473,0,0,1,51.732.094a.676.676,0,0,0-.687,0A52.009,52.009,0,0,1,38.179,5.551a.676.676,0,0,0-.5.652v6.909a19.877,19.877,0,0,0,6.036,14.523c2.964,2.9,6.418,4.511,7.671,4.511S56.1,30.54,59.06,27.635A19.877,19.877,0,0,0,65.1,13.112V6.2A.676.676,0,0,0,64.6,5.551Zm-.855,7.561a18.551,18.551,0,0,1-5.63,13.557c-2.915,2.856-6.032,4.125-6.725,4.125s-3.81-1.268-6.725-4.125a18.552,18.552,0,0,1-5.63-13.557v-6.4A53.255,53.255,0,0,0,51.389,1.46,54.94,54.94,0,0,0,63.743,6.716Z",
    transform: "translate(-37.681 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M85.363,99.372a.676.676,0,0,0-.877-.381c-1.208.476-2.448.914-3.685,1.3a.676.676,0,0,0-.474.645v2.611a.676.676,0,1,0,1.352,0v-2.117c1.11-.359,2.219-.756,3.3-1.183A.676.676,0,0,0,85.363,99.372Z",
    transform: "translate(-77.649 -92.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M170.88,87.561a.677.677,0,0,0,.271-.057l.012-.005a.676.676,0,1,0-.546-1.237l-.011,0a.676.676,0,0,0,.273,1.295Z",
    transform: "translate(-161.882 -80.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M308.416,345.638a.676.676,0,0,0-.936.2,16.462,16.462,0,0,1-1.943,2.427,17.271,17.271,0,0,1-1.94,1.726.676.676,0,1,0,.82,1.075,18.646,18.646,0,0,0,2.092-1.861,17.8,17.8,0,0,0,2.1-2.628A.676.676,0,0,0,308.416,345.638Z",
    transform: "translate(-286.652 -323.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M276.94,432.059l-.039.023a.676.676,0,1,0,.677,1.17l.045-.026a.676.676,0,1,0-.683-1.167Z",
    transform: "translate(-261.565 -404.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M126.574,159.585a2.2,2.2,0,0,0-3.11,3.11l3.993,3.993a2.2,2.2,0,0,0,3.11,0l8.335-8.335a2.2,2.2,0,0,0-3.11-3.11l-6.781,6.781Zm10.175-3.386a.846.846,0,1,1,1.2,1.2l-8.335,8.335a.847.847,0,0,1-1.2,0l-3.993-3.993a.847.847,0,0,1,1.2-1.2l2.916,2.916a.676.676,0,0,0,.956,0Z",
    transform: "translate(-117.476 -144.892)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(60 18.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M.5.7H4.4c3.8,0,5.7,1.9,5.7,5.2,0,3.5-2,5.5-5.8,5.5H.4V.7ZM4.3,9C6.1,9,6.9,8,6.9,6c0-2.2-.8-3-2.7-3H3.5V9h.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M10.9,9.2c0-1.8,1.6-2.6,4.2-2.6h.8V6.4c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H11.3c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H16v-.9a2.571,2.571,0,0,1-2.3,1.1A2.488,2.488,0,0,1,11,9.2Zm4.9-.5V8.2h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7a1.221,1.221,0,0,0,1.3-1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M20.3,8.9V5.4h-.9V3.6h.9V2H23V3.6h1.5V5.4H23V8.6c0,.6.3.8.8.8a1.719,1.719,0,0,0,.8-.1v2c-.3,0-.9.2-1.5.2-1.8,0-2.8-.9-2.8-2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M25.3,9.2c0-1.8,1.6-2.6,4.2-2.6h.8V6.4c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H25.7c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H30.4v-.9a2.571,2.571,0,0,1-2.3,1.1,2.488,2.488,0,0,1-2.7-2.4Zm5-.5V8.2h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7a1.221,1.221,0,0,0,1.3-1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M37.7.7h4.1c2.9,0,4.3,1.3,4.3,3.6s-1.5,3.5-4.2,3.5H40.7v3.6H37.6V.7Zm3.9,5c1,0,1.5-.5,1.5-1.3,0-1-.5-1.4-1.5-1.4h-.9V5.7h.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M47.2,3.6h2.7V5.2a2.457,2.457,0,0,1,2.5-1.7V6c-1.6,0-2.5.5-2.5,1.7v3.7H47.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M53.6,1.4a1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,1-3,0m.1,2.2h2.7v7.8H53.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M57.4,3.6h2.9l1.6,5.1,1.6-5.1h2.6l-2.9,7.8H60.3L57.4,3.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M66.2,9.2c0-1.8,1.6-2.6,4.2-2.6h.8V6.4c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H66.6c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H71.3v-.9A2.571,2.571,0,0,1,69,11.6a2.488,2.488,0,0,1-2.7-2.4Zm4.9-.5V8.2h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7A1.221,1.221,0,0,0,71,8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M74.9,7.6h0a3.986,3.986,0,0,1,4.2-4.2c2.3,0,3.7.8,3.8,3.2H80.4a1.164,1.164,0,0,0-1.3-1.1c-.8,0-1.5.7-1.5,2,0,1.5.5,2.2,1.5,2.2s1.3-.5,1.4-1.3h2.4c0,2-1.4,3.3-3.9,3.3s-4.1-1.4-4.1-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M86.2,10.6l-3.1-7H86l1.6,4.2,1.5-4.2h2.6L87.5,14.1H84.9l1.3-3.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M0,26.1H0a5.276,5.276,0,0,1,5.5-5.6c3.2,0,4.7,1.3,5,4.1H7.3a1.653,1.653,0,0,0-1.8-1.7c-1.1,0-2.2,1.1-2.2,3,0,2.1.8,3.1,2.3,3.1s1.8-.6,2-1.8h3.1c-.2,2.8-2.2,4.2-5,4.2A5.564,5.564,0,0,1,.1,25.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M11.3,27.6h0a4.068,4.068,0,0,1,4.3-4.2c2.4,0,4.3,1.5,4.3,4a4.013,4.013,0,0,1-4.3,4.2c-2.4,0-4.3-1.5-4.3-4m5.9-.1h0c0-1.4-.5-2.2-1.5-2.2s-1.6.7-1.6,2c0,1.5.5,2.2,1.6,2.2s1.5-.8,1.5-2.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M21.1,23.6h2.7v1.2a2.6,2.6,0,0,1,2.5-1.4,1.89,1.89,0,0,1,2.1,1.3A3.172,3.172,0,0,1,31,23.4c1.5,0,2.6,1,2.6,2.9v5.1H30.9V26.7c0-.8-.4-1.2-1-1.2a1.241,1.241,0,0,0-1.2,1.3v4.5H26V26.6c0-.8-.4-1.2-1-1.2a1.241,1.241,0,0,0-1.2,1.3v4.5H21.1V23.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M35,23.6h2.7v1.2a2.655,2.655,0,0,1,2.4-1.4c1.8,0,3.3,1.4,3.3,4.1,0,2.8-1.5,4.2-3.3,4.2s-2-.6-2.4-1.3v3.8H35V23.6Zm5.8,3.9h0c0-1.5-.6-2.2-1.5-2.2s-1.6.7-1.6,2c0,1.5.6,2.1,1.6,2.1s1.5-.7,1.5-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 2.7,
    height: 11.3,
    transform: "translate(44.8 20.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M49,21.4a1.5,1.5,0,1,1,1.5,1.4A1.394,1.394,0,0,1,49,21.4m.2,2.2h2.7v7.8H49.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M53.1,29.2c0-1.8,1.6-2.6,4.2-2.6h.8v-.2c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H53.5c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H58.2v-.9a2.571,2.571,0,0,1-2.3,1.1,2.488,2.488,0,0,1-2.7-2.4Zm4.9-.5v-.5h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7a1.221,1.221,0,0,0,1.3-1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M62.2,23.6h2.7v1.3a2.822,2.822,0,0,1,2.6-1.5c1.3,0,2.6.9,2.6,3v5.1H67.4V26.9c0-.9-.3-1.3-1.1-1.3s-1.3.5-1.3,1.5v4.4H62.3V23.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M71.9,28.9V25.4H71V23.6h.9V22h2.7v1.6h1.5v1.8H74.6v3.2c0,.6.3.8.8.8a1.719,1.719,0,0,0,.8-.1v2c-.3,0-.9.2-1.5.2-1.8,0-2.8-.9-2.8-2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M79.7,31l3.8-4c1.1-1.1,1.8-2.1,1.8-3s-.4-1.2-1.1-1.2-1.2.5-1.4,1.7H80c.1-2.7,1.7-4,4.3-4s4,1.4,4,3.4-.8,2.6-2,3.7l-1.5,1.5h3.6v2.3H79.8V31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M89.2,26.3v-.5c0-3.4,2.1-5.3,4.9-5.3S99,22.3,99,25.7v.4c0,3.4-1.9,5.4-5,5.4s-4.9-1.9-4.9-5.3Zm6.9-.1v-.4c0-2-.6-3-1.9-3s-1.9,1-1.9,3v.5c0,2,.6,2.9,1.9,2.9s1.8-1,1.8-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M99.8,31l3.7-4c1.1-1.1,1.8-2.1,1.8-3s-.4-1.2-1.1-1.2-1.2.5-1.4,1.7H100c.1-2.7,1.7-4,4.3-4s4,1.4,4,3.4-.8,2.6-2,3.7l-1.5,1.5h3.6v2.3H99.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M109.3,28h2.8c.1.8.4,1.2,1.4,1.2s1.3-.7,1.3-1.5a1.415,1.415,0,0,0-1.5-1.5,1.95,1.95,0,0,0-1.8.8h-1.8l.2-6.3h7.2v2.2h-5v2.4a2.523,2.523,0,0,1,2.4-1.1c2,0,3.3,1.3,3.3,3.6s-1.6,3.8-4.3,3.8S109.4,30.1,109.3,28Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacy);
export default __webpack_public_path__ + "static/media/DataPrivacy.7cda834951aa7b57f49b7ac73886898a.svg";
export { ForwardRef as ReactComponent };